module.exports = function(approval) {
	"use strict";
  approval
  .controller('allApprovalsController', allApprovalsController);
	allApprovalsController.$inject = ["$http","cleanObj","API_URL","authtokenService","postDataService","$timeout","$stateParams","$state","config","$scope","$rootScope","NgTableParams","getDataService","jQuery","refreshtokenService","$compile","putDataService","alertService","serverError","keyPressOnlyNumber","offlineError",'downloadPdf'];
	
  function allApprovalsController($http,cleanObj, API_URL,authtokenService,postDataService,$timeout,$stateParams,$state,config,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,$complie,putDataService,alertService,serverError,keyPressOnlyNumber,offlineError, downloadPdf) {
    var vmaa = this;
    vmaa.config = config;
    $rootScope.emptyTable = false;
    var state = 'approvals';
    var page = 1;
    var user;
    var date_start;
    var date_end;
    var sortby ='date';
    var s;
    var type;
    var document_id;
    var $data;
    vmaa.status = 'all';
    vmaa.switchDate =false;
    vmaa.switchSearch = false;
    // vmaa.selectedMediaAction = {value: 'default'};
    vmaa.selectedUserFilter = {value: 'all'};
    $scope.ranges = {
      'Today': [moment().startOf('day'), moment()],
      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
      'Last 7 days': [moment().subtract('days', 7), moment()],
      'Last 30 days': [moment().subtract('days', 30), moment()],
      'This month': [moment().startOf('month'), moment().endOf('month')],
      'All days':[moment().subtract('year',5),moment()]
    };
    vmaa.state = {
      'photo':'library',
      'post': 'allposts',
      'video': 'allvideos'
    };
    vmaa.getUiSref = function(approval,id) {
      return $state.href('app.' + vmaa.state[approval.type], {'id': id})
    }
    vmaa.downloadApproval = downloadPdf;
    // vmaa.deletePosts = function(approval) {
    //   $rootScope.hasLoaded = false;	
    //   postDataService.save({
    //     param1: state,
    //     param2:'remove',
    //     param3:approval._id,
    //   },{
    //     'document_ids': approval.document_ids,
    //     'type': approval.type
    //   }).$promise.then(function(data){
    //     $rootScope.hasLoaded = true;
    //     alertService('success','Success ', data.message, 2000);
    //     vmaa.tableParams.reload();
    //   }, function(error){
    //     if(!window.navigator.onLine) {
    //       offlineError()
    //       $rootScope.hasLoaded = true;
    //       alertService('danger','Opps! ', 'Please check your internet connection and try again.');
    //       return
    //     }
    //     if(error.status ==401) {
    //       var promise = refreshtokenService.getAccessToken();
    //       promise.then(
    //       function(answer) {
    //         if(answer==200) {
    //         unlockFunction()
    //         }
    //       },
    //       function(error) {
    //         // report something
    //       },
    //       function(progress) {
    //       // report progress
    //       });
    //     } else if(error.status ==502) {
    //       serverError()
    //     } else {
    //       alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
    //     }
    //     $rootScope.hasLoaded = true;
    //   }); 
    // }
    var getusersFunction = function() {
      getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
        vmaa.usersList = data.users;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getusersFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
              });
        } else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      });
    }
    getusersFunction();
    vmaa.changeSearch = function(search_data) {
      if(search_data) {
        s = search_data;
      } else {
        s = null;
        $timeout(function() {
          vmaa.search();
        },0)            
      }
    }
    vmaa.switchUserFilter = function(item) {
      user = item;
      if (item=='all') {
        user = null;
      }
    }
    vmaa.changeDate = function(value) {
      vmaa.dateRangevalue= value;
      vmaa.switchDate = true;
      if(vmaa.dateRangevalue) {
        if(value.startDate && value.endDate) {
          date_start = value.startDate.format('YYYY-MM-DD');
          date_end = value.endDate.format('YYYY-MM-DD');
        } else {
          date_start = null;
          date_end = null;
        }
      } else {
        date_start = null;
        date_end = null;
      }
    }
    function reloadTableFunction () {
      if(vmaa.tableParams.page() ==1) {
        vmaa.tableParams.reload();
      } else {
        vmaa.tableParams.page(1);
      }
    } 
    vmaa.mediaFilters = function() {
      reloadTableFunction();
    }
    vmaa.resetAllFilters = function() {
      vmaa.status = 'all';
      vmaa.searchData = null;
      s =null;
      user = null;
      vmaa.selectedUserFilter = {value: 'all'};
      document_id = null;
      type = null;
      date_start = null;
      date_end = null;
      $scope.$broadcast('clear-daterange',true);
      reloadTableFunction();
    }
    vmaa.userApproval = function(value) {
      user = value;
      reloadTableFunction();
    }
    vmaa.typeApproval = function(value) {
      type = value;
      reloadTableFunction();
    }
    vmaa.changeStatus =function(activeStatus) {
      vmaa.status = activeStatus;
      if(activeStatus =='all') {
        type= null
      } else {
        type = activeStatus;
      }
      reloadTableFunction();
    }
    vmaa.search =function(value) {
      if(value) {
        s = value.toLowerCase();
      } else {
        s = null;
      }
      reloadTableFunction();
    }
    vmaa.tableReloadFunction = function(page) { 
      vmaa.tableParams = new NgTableParams({
          page: page || 1,
          count: 20,
        }, {
        getData: function(params) {
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,
            page: params.page(),
            limit: params.count(),
            user: user,
            s:s,
            type:type,
            document_id:document_id,
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            date_start: date_start,
            date_end: date_end
            }).$promise.then(function(data){
              $rootScope.hasLoaded = true;
              $data =data.approvals;
              $rootScope.emptyTable = false;
              params.total(data.count);
              params.numPages(data.max_pages);
              jQuery('.goTo input').val("");
              if(user) {
                vmaa.selectedUserFilter = {value: user.toString()};
              }
              if(type) {
                vmaa.status = type;
              }
              return $data;
            }, function(error){
              if(!window.navigator.onLine) {
                $rootScope.hasLoaded = true;
                offlineError('refresh')
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {
                      vmaa.tableReloadFunction(params.page());
                    }
                    // do something
                  },
                  function(error) {
                  },
                  function(progress) {
                   // report progress
                  });
              } else if(error.status ==404) {
                $rootScope.emptyTable = true;
              } else if(error.status ==502) {
                serverError();
              } else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;
            });
          }    
      });
    }
    vmaa.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/approvalsModule/allapprovals/js/allApprovalsController.js
// module id = 490
// module chunks = 0